$(document).ready(function () {
	// Smooth scroll global hash
	$(document).on('click', 'a[href^="#"]', function (event) {
		event.preventDefault()
		$('html, body').animate(
			{
				scrollTop: $($.attr(this, 'href')).offset().top - 70,
			},
			1000,
		)
	})

	// Smooth scroll to single target
	const smoothScrollingTo = (target) => {
		$('html,body').animate({ scrollTop: $(target).offset().top - 20 }, 1000)
	}

	// Fancybox global init
	Fancybox.bind('[data-fancybox]')

	// Fancybox custom dialog & options
	Fancybox.bind('[data-fancybox-prices-dialog]', {
		backdropClick: false,
		on: {
			close: () => {
				console.log('Modal closed')
			},
			destroy: () => {
				smoothScrollingTo('#competition__step-two')
				console.log('Modal destroyed')
			},
			loaded: () => {
				// smoothScrollingTo('#competition__step-two');
				console.log('Modal loaded')
			},
		},
		selector: 'wadwa',
	})

	$('#want-trip-button').click(function () {
		console.log('clicked')
	})

	// 504
	var counter = 17
	var interval = setInterval(function () {
		counter--

		if (counter <= 0) {
			clearInterval(interval)
			$('.shutdown__timer').hide()
			$('.shutdown__reload-icon').show()
			$('.shutdown__reload-btn').addClass('shutdown__refresh-enable')
			return
		} else {
			$('.shutdown__time').text(counter)
		}
	}, 1000)

	// Header & Nav + responsive
	$('.desktop-nav li').click(function () {
		$(this).addClass('active')
		$(this).parent().children('li').not(this).removeClass('active')
	})

	$('.mobile-nav-icon').click(function () {
		$('.header__mob-nav__holder').css('display', 'flex')
	})

	$('.header__mobile-close').click(function () {
		$('.header__mob-nav__holder').hide()
	})

	$('.header__mobile-logo a').click(function () {
		$('.header__mob-nav__holder').hide()
	})

	$('.header__mob-nav__holder li').click(function () {
		$('.header__mob-nav__holder').hide()
	})

	// Fajn soutěž
	$('#submit-compete-button').click(function () {
		$('#prices-dialog-part-one').hide()
		$('#prices-dialog-part-two').show()
	})

	$('#create-thumbnail').click(function () {
		$('.selected-image').show()
	})

	$('.competition__select-bg div').click(function () {
		$('.selected-image').hide()
		$('.competition__generated').html('').removeClass('opacity').addClass('opacity')
		$(this).addClass('selected').siblings().removeClass('selected')
		$(this).find('img').clone().appendTo('.competition__generated')
	})

	// Review
	const sliderArrow = '<div class="slider-arrow"></div>'

	const breakpoint = 1200

	const shareData = {
		title: 'MDN',
		text: 'Learn web development on MDN!',
		url: 'https://developer.mozilla.org',
	}

	// Share must be triggered by "user activation"
	document.querySelectorAll('.share-btn').forEach((btn) => {
		btn.addEventListener('click', async () => {
			try {
				await navigator.share(shareData)
			} catch (err) {
				console.error(err)
			}
		})
	})

	tippy('[data-tippy-content]', {
		placement: 'top',
	})

	// Reactions slider
	var slider,
		sliderSettings = {
			auto: false,
			autoControls: true,
			speed: 500,
			minSlides: 4,
			maxSlides: 4,
			moveSlides: 1,
			slideWidth: 360,
			slideMargin: 20,
			pager: false,
			nextText: sliderArrow,
			prevText: sliderArrow,
			touchEnabled: false,
		}

	// Review slider
	var slider2,
		slider2Settings = {
			auto: false,
			autoControls: true,
			speed: 500,
			minSlides: 3,
			maxSlides: 3,
			moveSlides: 1,
			slideWidth: 500,
			slideMargin: 30,
			pager: true,
			nextText: sliderArrow,
			prevText: sliderArrow,
			touchEnabled: false,
		}

	// Offers slider
	var slider3,
		slider3Settings = {
			auto: false,
			autoControls: true,
			speed: 500,
			minSlides: 8,
			maxSlides: 8,
			moveSlides: 1,
			slideWidth: 160,
			slideMargin: 20,
			pager: false,
			nextText: sliderArrow,
			prevText: sliderArrow,
			touchEnabled: false,
		}

	function init() {
		// Review slider
		slider2Settings.maxSlides = window.outerWidth < breakpoint ? 1 : 3
		slider2Settings.minSlides = window.outerWidth < breakpoint ? 1 : 3
		slider2Settings.slideMargin = window.outerWidth < breakpoint ? 8 : 20
		// Offers slider
		slider3Settings.maxSlides = window.outerWidth < breakpoint ? 2 : 8
		slider3Settings.minSlides = window.outerWidth < breakpoint ? 2 : 8
		slider3Settings.pager = window.outerWidth < breakpoint ? true : false
		// Reaction slider
		sliderSettings.maxSlides = window.outerWidth < breakpoint ? 1 : 4
		sliderSettings.minSlides = window.outerWidth < breakpoint ? 1 : 4
		sliderSettings.pager = window.outerWidth < breakpoint ? true : false
	}

	init()
	slider2 = $('.review__slider').bxSlider(slider2Settings)
	slider3 = $('.offers__slider').bxSlider(slider3Settings)
	slider = $('.reactions__slider').bxSlider(sliderSettings)

	$(window).resize(function () {
		if ((window.outerWidth < breakpoint && window.prevWidth >= breakpoint) || (window.outerWidth >= breakpoint && window.prevWidth < breakpoint)) {
			// Review slider
			slider2Settings.maxSlides = window.outerWidth < breakpoint ? 1 : 3
			slider2Settings.minSlides = window.outerWidth < breakpoint ? 1 : 3
			slider2Settings.slideMargin = window.outerWidth < breakpoint ? 8 : 20
			slider2.reloadSlider(slider2Settings)
			// Offers slider
			slider3Settings.maxSlides = window.outerWidth < breakpoint ? 2 : 8
			slider3Settings.minSlides = window.outerWidth < breakpoint ? 2 : 8
			slider3Settings.pager = window.outerWidth < breakpoint ? true : false
			slider3.reloadSlider(slider3Settings)
			// Reactions slider
			sliderSettings.maxSlides = window.outerWidth < breakpoint ? 1 : 4
			sliderSettings.minSlides = window.outerWidth < breakpoint ? 1 : 4
			sliderSettings.pager = window.outerWidth < breakpoint ? true : false
			slider.reloadSlider(sliderSettings)
		}
		window.prevWidth = window.outerWidth
	})
})
